export const SendTeacherParentInviteSources = Object.freeze({
  sltInviteAllParentsModal: "slt-invite-all-parents-modal",
  classBatchInvite: "class-batch-invite",
  classesBatchInvite: "classes-batch-invite",
  classStudentsPage: "class-students-page",
  manageStudentModal: "manage-student-modal",
  createAssignment: "create-assignment",
  nonSltHomepageParents: "nonSLT-homepage-parents"
});
export type SendTeacherParentInviteSource =
  typeof SendTeacherParentInviteSources[keyof typeof SendTeacherParentInviteSources];

export const inviteAllParentsTileActions = Object.freeze({
  findOutMore: "find-out-more",
  inviteParents: "invite-parents"
});
export type InviteAllParentsTileAction =
  typeof inviteAllParentsTileActions[keyof typeof inviteAllParentsTileActions];

export const inviteClassParentsTileActions = Object.freeze({
  inviteClassParentsClick: "invite-parents-click"
});
export type InviteClassParentsTileAction =
  typeof inviteClassParentsTileActions[keyof typeof inviteClassParentsTileActions];
